import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import Button from '@mui/material/Button';

import classes from './TopSection.module.css';

const TopSection = ({ productData }) => {
  return (
    <>
      <div className={classes.topContainer}>
        <aside className={classes.infoContainer}>
          <figure className={classes.udcLogo}>
            <img
              className={classes.img}
              src="https://d1g6c01s9ssd7h.cloudfront.net/img/LogoUDC_EduStore.png"
              alt="UDC"
            />
          </figure>
          <div className={classes.complementaryInfoContainer}>
            <figure className={classes.imgCourse}>
              <img
                className={classes.img}
                src={productData.img}
                alt={productData.title}
              />
            </figure>
            <p className={classes.title}>{productData.title}</p>
            <p className={classes.academy}>
              Universidad de las Ciencias
            </p>
            <p className={classes.description}>
              {productData.title}
            </p>
            <Button
              className={classes.btnPay}
              component={Link}
              to="/preregister"
            >
              Proceso de inscripción
            </Button>
          </div>
        </aside>
      </div>
      <div className={classes.topContainerFixed}>
        <aside className={classes.infoContainer}>
          <figure className={classes.udcLogo}>
            <img
              className={classes.img}
              src="https://d1g6c01s9ssd7h.cloudfront.net/img/LogoUDC_EduStore.png"
              alt="UDC"
            />
          </figure>
          <div className={classes.complementaryInfoContainer}>
            <figure className={classes.imgCourse}>
              <img
                className={classes.img}
                src={productData.img}
                alt={productData.title}
              />
            </figure>
            <p className={classes.title}>{productData.title}</p>
            <p className={classes.academy}>
              Universidad de las Ciencias
            </p>
            <p className={classes.description}>
              {productData.title}
            </p>
            <Button
              className={classes.btnPay}
              component={Link}
              to="/preregister"
            >
              Proceso de inscripción
            </Button>
          </div>
        </aside>
      </div>
    </>
  );
};

TopSection.propTypes = {
  // eslint-disable-next-line react/require-default-props
  productData: PropTypes.object
};

export default TopSection;
